import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Panel, Btn, Field, inputCls, SingleImageUploader } from "./AdminUI";
import { Plus, Pencil, Trash2 } from "lucide-react";

const empty = { title: "", category: "General", description: "", date: "", is_urgent: false, file_path: null };
const CATS = ["General", "Elections", "Rules", "Events"];

export default function ManageNotices() {
  const [list, setList] = useState([]);
  const [form, setForm] = useState(null);

  const load = () => api.get("/notices").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    if (form.id) await api.put(`/notices/${form.id}`, form);
    else await api.post("/notices", form);
    setForm(null); load();
  };
  const del = async (id) => { if (window.confirm("Delete this notice?")) { await api.delete(`/notices/${id}`); load(); } };

  return (
    <Panel title="Manage Notices" actions={<Btn onClick={() => setForm({ ...empty })} data-testid="add-notice"><Plus size={15} /> Add Notice</Btn>}>
      {form && (
        <form onSubmit={save} className="mb-6 p-4 rounded-lg bg-[#FAF7F0] border border-[#E5DECF] space-y-3" data-testid="notice-form">
          <div className="grid sm:grid-cols-2 gap-3">
            <Field label="Title"><input className={inputCls} required value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} data-testid="notice-title" /></Field>
            <Field label="Date"><input type="date" className={inputCls} value={form.date} onChange={(e) => setForm({ ...form, date: e.target.value })} data-testid="notice-date" /></Field>
            <Field label="Category">
              <select className={inputCls} value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })}>
                {CATS.map((c) => <option key={c}>{c}</option>)}
              </select>
            </Field>
            <Field label="Urgent">
              <label className="flex items-center gap-2 text-sm mt-2"><input type="checkbox" checked={form.is_urgent} onChange={(e) => setForm({ ...form, is_urgent: e.target.checked })} /> Mark as urgent</label>
            </Field>
          </div>
          <Field label="Description"><textarea rows={3} className={inputCls} value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} data-testid="notice-desc" /></Field>
          <Field label="Attachment (PDF / Image, optional)"><SingleImageUploader path={form.file_path} onChange={(p) => setForm({ ...form, file_path: p })} label="Upload PDF / image" accept=".pdf,image/*" /></Field>
          <div className="flex gap-2"><Btn type="submit" data-testid="notice-save">Save</Btn><Btn type="button" variant="outline" onClick={() => setForm(null)}>Cancel</Btn></div>
        </form>
      )}
      <div className="space-y-2">
        {list.map((n) => (
          <div key={n.id} className="flex items-center justify-between gap-3 border border-[#F0E9DA] rounded-lg px-4 py-3" data-testid={`admin-notice-${n.id}`}>
            <div>
              <div className="font-medium text-[#2a2422]">{n.title} {n.is_urgent && <span className="text-xs text-[#C53030]">• Urgent</span>}</div>
              <div className="text-xs text-[#5A6270]">{n.category} · {n.date}</div>
            </div>
            <div className="flex gap-2">
              <Btn variant="outline" onClick={() => setForm(n)}><Pencil size={14} /></Btn>
              <Btn variant="danger" onClick={() => del(n.id)} data-testid={`delete-notice-${n.id}`}><Trash2 size={14} /></Btn>
            </div>
          </div>
        ))}
      </div>
    </Panel>
  );
}
